import { environment } from '../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { SharedModule } from './../app/shared.module';
import { CommonModule } from '@angular/common';
import { NgbModule, NgbActiveModal, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { TreeModule } from 'angular-tree-component';
import { AppComponent } from './app.component';
import { EmployeeRegistrationComponent } from './admin/employee-registration/employee-registration.component';
import { EmployeeListComponent } from './admin/employee-list/employee-list.component';
import { PatientListComponent } from './admin/patient-list/patient-list.component';
import { StaffRegistrationComponent } from './admin/staff-registration/staff-registration.component';
import { EmployeeService } from './services/employee.service';
import { PatientService } from './services/patient.service';
import { FirebaseMessage } from './services/firebasemessages';
import { AuthenticationService } from './services/authentication.service';
import { AnalyticsService } from './services/analytics.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpConfigInterceptor } from '../app/services/httpconfig.interceptor';

import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PatientComponent } from './patient/patient.component';
import { DoctorComponent } from './doctor/doctor.component';
import { PartnerComponent } from './partner/partner.component';
import { BusinessComponent } from './business/business.component';
import { EmployeeProfileComponent } from './admin/employee-profile/employee-profile.component';
import { PaymentresponseComponent } from './paymentresponse/paymentresponse.component';
import { CustomFormsModule } from 'ng4-validators';
import { UserServices } from './services/userservices.service';
import { StaffListComponent } from './admin/staff-list/staff-list.component';
import { StaffProfileComponent } from './admin/staff-profile/staff-profile.component';

import { EmployeeSlotsComponent } from './admin/employee-slots/employee-slots.component';
import { DeshboardComponent } from './admin/deshboard/deshboard.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { EditEmployeeComponent } from './admin/edit-employee/edit-employee.component';
import { AmazingTimePickerModule } from 'amazing-time-picker';
import { SlotsService } from './services/slots.services';
import { EditStaffComponent } from './admin/edit-staff/edit-staff.component';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
import { APIService } from './services/api.service';
import { CouponComponent } from './admin/coupon/coupon.component';
import { CouponService } from './services/coupon.service';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { UserCouponsComponent } from './admin/user-coupons/user-coupons.component';
import { FirstavailableDoctorsComponent } from './admin/firstavailable-doctors/firstavailable-doctors.component';
import { menurolesService } from './services/menuroles.service';
import { RoleAccessibilityComponent } from './admin/role-accessibility/role-accessibility.component';
import { ModalModule } from 'ng-bootstrap-modal';
import { DialogComponent } from './shared/dialog/dialog.component';
import { PharmacyComponent } from './pharmacy/pharmacy.component';
import { DeeplinkComponent } from './deeplink/deeplink.component';
import { CorporatePartnerComponent } from './admin/corporate-partner/corporate-partner.component';
import { LaboratoryTestComponent } from './admin/laboratory-test/laboratory-test.component';
import { PartnerService } from './services/partner.service';
import { PartnerProductComponent } from './admin/partner-product/partner-product.component';
import { DataTableModule } from "angular-6-datatable";
import { NgxPaginationModule } from 'ngx-pagination';
import { PartnerDashboardComponent } from './partnerUI/partner-dashboard/partner-dashboard.component';
import { PartnerOrdersComponent } from './partnerUI/partner-orders/partner-orders.component';
import { PartnerManageProductComponent } from './partnerUI/partner-manage-product/partner-manage-product.component';
import { PartnerLoginComponent } from './partnerUI/partner-login/partner-login.component';
import { ExcelService } from './services/excel.service';
import { UserFaqComponent } from './user-faq/user-faq.component';
import { FileUploadModule } from 'ng2-file-upload';
import { DataFilterPipe } from './data-filter.pipe';
import { NgxUiLoaderModule, NgxUiLoaderHttpModule, POSITION } from 'ngx-ui-loader';
import { DataTablesModule } from 'angular-datatables';
import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { GenerateReportComponent } from './admin/generate-report/generate-report.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AddFirebaseMessagesComponent } from './admin/add-firebase-messages/add-firebase-messages.component';
import { AssginMessagesComponent } from './admin/assgin-messages/assgin-messages.component';
import { ApiResponseComponent } from './api-response/api-response.component';
import { EncryptDecryptService } from './services/encryptdecrypt.service';
import { UploadedorderService } from './services/uploadedorder.service';

import {NgxImageCompressService} from 'ngx-image-compress';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { AddSubscriptionComponent } from './admin/add-subscription/add-subscription.component';
import { AssignSubscriptionComponent } from './admin/assign-subscription/assign-subscription.component';

import { BookAppointmentComponent } from './admin/book-appointment/book-appointment.component';
import { SubscriptionComponent } from './admin/subscription/subscription.component';
import { EditsubscriptionComponent } from './admin/editsubscription/editsubscription.component';
import { SubscriptionProductComponent } from './admin/subscription-product/subscription-product.component';
import { ImportCouponComponent } from './admin/import-coupon/import-coupon.component';
import { UploadedOrderComponent } from './admin/uploaded-order/uploaded-order.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';


@NgModule({
  declarations: [
    AppComponent,
    EmployeeRegistrationComponent,
    EmployeeListComponent,
    PatientListComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LoginComponent,
    PatientComponent,
    DoctorComponent,
    PartnerComponent,
    BusinessComponent,
    EmployeeProfileComponent,
    PaymentresponseComponent,
    StaffRegistrationComponent,
    StaffListComponent,
    StaffProfileComponent,
    EmployeeSlotsComponent, DeshboardComponent, TermsAndConditionsComponent, EditEmployeeComponent, EditStaffComponent, UnderConstructionComponent, CouponComponent, UserCouponsComponent, FirstavailableDoctorsComponent, RoleAccessibilityComponent, DialogComponent, PharmacyComponent, DeeplinkComponent, CorporatePartnerComponent, LaboratoryTestComponent, PartnerProductComponent, PartnerDashboardComponent, PartnerOrdersComponent, PartnerManageProductComponent, PartnerLoginComponent, UserFaqComponent, DataFilterPipe, GenerateReportComponent, AddFirebaseMessagesComponent, AssginMessagesComponent, ApiResponseComponent, AddSubscriptionComponent, AssignSubscriptionComponent , BookAppointmentComponent , SubscriptionComponent , EditsubscriptionComponent , SubscriptionProductComponent, ImportCouponComponent, UploadedOrderComponent, PrivacyPolicyComponent

  ],
  imports: [
    TabsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    DataTablesModule,
    Ng2ImgMaxModule,
    NgxUiLoaderHttpModule.forRoot({ showForeground: true, exclude: [environment.apiURL + '/api/getUserMenus'] }),
    NgxUiLoaderModule.forRoot({
      "bgsColor": "#2A3F54",
      "bgsOpacity": 0.5,
      "bgsPosition": "bottom-right",
      "bgsSize": 60,
      "bgsType": "fading-circle",
      "blur": 10,
      "fgsColor": "#2A3F54",
      "fgsPosition": "center-center",
      "fgsSize": 80,
      "fgsType": "fading-circle",
      "gap": 24,
      "logoPosition": "center-center",
      "logoSize": 120,
      "logoUrl": "",
      "overlayColor": "rgba(60, 128, 255, 0)",
      "pbColor": "#2A3F54",
      "pbDirection": "ltr",
      "pbThickness": 3,
      "hasProgressBar": false,
      "text": "",
      "textColor": "#FFFFFF",
      "textPosition": "center-center",


    }), NgxPaginationModule, DataTableModule, BrowserModule, CommonModule, SharedModule,
    AppRoutingModule, HttpClientModule, ReactiveFormsModule, FileUploadModule,
    FormsModule, TreeModule, NgbModule.forRoot(), CustomFormsModule, AmazingTimePickerModule, Ng2TelInputModule, ModalModule.forRoot([{ name: 'confirm', component: DialogComponent }])
  ],

  providers: [FirebaseMessage, EmployeeService,NgxImageCompressService, UserServices,EncryptDecryptService, PatientService, AuthenticationService, SlotsService, AnalyticsService, APIService, CouponService, NgbDatepicker, NgbActiveModal, menurolesService, PartnerService, ExcelService, UploadedorderService, { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }],
  bootstrap: [AppComponent],

})
export class AppModule { }




// WEBPACK FOOTER //
// ./src/app/app.module.ts